import { SVGProps } from 'react'

const SvgClientArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="10"
    height="6"
    viewBox="0 0 10 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.90941 0.468109L4.99941 3.37811L2.08941 0.468109C1.94593 0.34524 1.76137 0.281035 1.57262 0.288326C1.38386 0.295617 1.2048 0.373866 1.07123 0.507437C0.937662 0.641008 0.859413 0.820062 0.852122 1.00882C0.844831 1.19758 0.909036 1.38213 1.03191 1.52561L4.47441 4.96811C4.61493 5.1078 4.80502 5.1862 5.00316 5.1862C5.20129 5.1862 5.39138 5.1078 5.53191 4.96811L8.97441 1.52561C9.11409 1.38509 9.1925 1.195 9.1925 0.996859C9.1925 0.79872 9.11409 0.608631 8.97441 0.468109C8.83195 0.329208 8.64087 0.251465 8.44191 0.251465C8.24294 0.251465 8.05186 0.329208 7.90941 0.468109Z"
      fill="#464646"
    />
  </svg>
)

export default SvgClientArrow
